import { render, staticRenderFns } from "./CreateMegaTournament.vue?vue&type=template&id=29b4abfc&scoped=true&lang=pug"
import script from "./CreateMegaTournament.vue?vue&type=script&lang=js"
export * from "./CreateMegaTournament.vue?vue&type=script&lang=js"
import style0 from "./CreateMegaTournament.vue?vue&type=style&index=0&id=29b4abfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b4abfc",
  null
  
)

export default component.exports